import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ICoordinates } from '../models/iCoordinates';
import { MapService } from '../map.service';

@Component({
  selector: 'rc-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy {

  constructor(protected mapService: MapService) {
  }

  coordiantes: ICoordinates;
  isVisible = false;
  ngInitUnsubscribe: Subject<void> = new Subject<void>();

  ngOnInit() {
    this.isVisible = false;
    this.mapService.getCoordinates().pipe(takeUntil(this.ngInitUnsubscribe)).subscribe((data: ICoordinates) => {

      this.isVisible = !!data && !!data.Latitude && !!data.Longitude;
      this.coordiantes = data;
    });
  }

  checkIfVisible(){
    return this.isVisible;
  }

  ngOnDestroy() {
    this.ngInitUnsubscribe.next();
    this.ngInitUnsubscribe.complete();
  }

}
